import {SearchInput} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import {TeamFilter} from './TeamFilter';
import {TeamStatusTabs} from './TeamStatusTabs';

import type {TeamFilterState} from '../config/team-filter.config';
import type {TeamStatusTab} from '../types';
import type {FirmMemberDTO} from '@sollapay/types';
import type {FC, ReactNode} from 'react';

export interface TeamListSectionHeaderProps {
  /** Already `countableTeamMembers`-filtered — see `TeamStatusTabsProps`. */
  countableMembers: FirmMemberDTO[];
  searchText: string;
  onSearchChange: (value: string) => void;
  statusTab: TeamStatusTab;
  onStatusTabChange: (tab: TeamStatusTab) => void;
  filter: TeamFilterState;
  onFilterChange: (filter: TeamFilterState) => void;
  exportMenu?: ReactNode;
}

/** Sorting lives on the table's column headers only — no sort control here. */
export const TeamListSectionHeader: FC<TeamListSectionHeaderProps> = ({
  countableMembers,
  searchText,
  onSearchChange,
  statusTab,
  onStatusTabChange,
  filter,
  onFilterChange,
  exportMenu
}) => {
  const {t} = useTranslation('team');

  return (
    <div className="flex items-center justify-between gap-4">
      <div className="flex items-center gap-3">
        <SearchInput
          value={searchText}
          onChange={onSearchChange}
          placeholder={t('search.placeholder')}
          className="w-80"
        />
        <TeamStatusTabs
          countableMembers={countableMembers}
          value={statusTab}
          onValueChange={onStatusTabChange}
        />
      </div>
      <div className="flex items-center gap-3">
        {exportMenu}
        <TeamFilter filter={filter} onChange={onFilterChange} />
      </div>
    </div>
  );
};
